import * as React from 'react'

import { useUnsafeAsyncData } from 'modules/core/hooks/useAsyncData'

import type SurveyForm from 'modules/surveys/store/models/Form'
import type Survey from 'modules/surveys/store/models/v2/Survey'

export function useRespondents(form: SurveyForm | Survey | null | undefined) {
  const [respondents, setRespondents] = React.useState<number[]>([])

  const fetchRespondents = async () => {
    if (!form) return

    const { access_ids } = await form.fetchRespondents()
    setRespondents(access_ids)
  }

  const { loading } = useUnsafeAsyncData(fetchRespondents, [form])

  return {
    loading,
    respondents,
    fetchRespondents,
  }
}
